import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscApiService } from 'src/app/_common/api/base-misc-api.service';
import { AppConstants } from 'src/app/_apps/app.constants';
import { QuotaApi } from './models';

@Injectable({
    providedIn: 'root'
})
export class QuotaMiscApiService extends BaseMiscApiService
{

    constructor(
        httpClient: HttpClient
    )
    {
        super(httpClient);

        this.segmentRoot = AppConstants.Configuration.apiUrlOstk;
        this.segmentApi = '/ostk/quotas';
    }

    getQuotas (): Observable<QuotaApi[]>
    {
        return this.get<QuotaApi[]>();
    }
}
